import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ContactsDialogComponent } from './contacts-dialog.component';
import { CustomMaterialModule } from '@sk/custom-material';
import { NgxMaskModule } from 'ngx-mask';


@NgModule({
  declarations: [
    ContactsDialogComponent
  ],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FlexLayoutModule,
    NgxMaskModule
  ]
})
export class ContactsDialogModule {
}
